import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    selectedSemester: null,
    students: [],
    studentId: null,
    studentEvaluation: {},
  },
  mutations: {
    SET_STUDENTS(state, data) {
      state.students = data
    },
  },
  actions: {
    async getStudents({ rootState, state, commit }, { param, page = 1, pageSize = 10, isLoadMore = false }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/student`,
          method: 'GET',
          params: {
            ...param,
            page: page,
            rows: pageSize,
          }
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        const results = res.data.results || []
        if (isLoadMore) {
          const newList = [...state.students, ...results]
          await commit('SET_STUDENTS', newList)
        } else {
          await commit('SET_STUDENTS', results)
        }
        return { results, status: 'success' };
      } else {
        //console.log('getstudent res = ', res)
        return { results: [], status: 'error' };
      }
    },
    async getStudentEvaluation({ rootState, state }, param) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom/get_student_evaluations_by_semester`,
          method: 'GET',
          params: param
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.studentEvaluation = res.data
      }

      return res
    },
  }
})